<!--
창고FAQ > 삭제 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical">

            <div class="uk-modal-header">
                <h4>창고FAQ 삭제</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">
                <app-column
                    class="uk-margin-small-bottom"
                    header="번호"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="100px"
                >
                    {{ id }}
                </app-column>

                <app-column
                    class="uk-margin-small-bottom"
                    header="제목"
                    header-size="medium"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="100px"
                >
                    {{ title }}
                </app-column>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <!-- 컨펌메세지 -->
                <div class="uk-margin-bottom">
                    정말 삭제합니까?
                </div>

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-danger"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: trash"></span>
                    삭제
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },

            /**
             * 삭제 후 이동url
             *  - 미설정시, 현재 페이지 새로고침
             */
            moveTo: {
                type: String,
                default: null,
            },


        },
        data: function () {
            return {
                /**
                 * (object) 창고FAQ 오브젝트
                 **/
                warehouse_faq: null,
            };
        },
        computed: {
            /**
             * id
             */
            id() {
                if (this.warehouse_faq) {
                    return this.warehouse_faq.id
                }
                return null;
            },
            /**
             * title
             */
            title() {
                if (this.warehouse_faq) {
                    return this.warehouse_faq.title
                }
                return null;
            },
        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param warehouse_faq_id 창고FAQID
             */
            form(warehouse_faq_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/warehouse_faqs/' + warehouse_faq_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.warehouse_faq = response.warehouse_faq;


                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * submit
             */
            submit() {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    // ajax 옵션
                    let opts = {
                        type: 'delete',
                        url: '/warehouse_faqs/' + this.warehouse_faq.id,
                        data: {
                            '_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    UIkit.modal.alert(response.msg).then(() => {
                        if (this.moveTo) {
                            $.app.move(this.moveTo);
                        } else {
                            $.app.refresh();
                        }
                    });

                });
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>